<template>
  <div class="w-1/3 viewer-right-panel" data-panel="screenshot">
    <div class="header relative w-full">
      <span class="m-3 block">{{ $t('screenshot') }}</span>
      <div class="viewer-panel__close-btn" @click="() => { $emit('epc-close', true) }">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="ga-left-panel-close"><g data-name="<Group>"><path d="M7.31 17.5a.5.5 0 0 1-.31-.85l10-10a.5.5 0 0 1 .71.71l-10 10a.5.5 0 0 1-.4.14z"></path><path d="M17.31 17.5a.5.5 0 0 1-.31-.15l-10-10a.5.5 0 0 1 .71-.71l10 10a.5.5 0 0 1-.4.86z"></path></g></svg>
      </div>
    </div>
    <div class="h-3" style="background: linear-gradient(to bottom, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0) 100%);"></div>
    <div class="bg-white">
      <div class="m-3">
        <b-icon icon="images" pack="fas"></b-icon>
        <span>{{ $t('design_image') }}</span>
      </div>

      <div class="m-3">
        <div>
          <div class="screenshot-container">
            <img :src="screenshot" alt="" class="img_screenshot">
          </div>
          <div class="flex items-center justify-between">
            <b-dropdown aria-role="list" position="is-top-right">
              <template #trigger>
                <b-button size="is-small" icon-left="download" icon-pack="fas">
                  {{ $t('download') }}
                  <b-icon icon="chevron-down" pack="fas" size="is-small"></b-icon>
                </b-button>
              </template>
              <b-dropdown-item aria-role="listitem" @click="_download('png')">
                <b-icon icon="image" pack="fas" size="is-small"></b-icon> PNG
              </b-dropdown-item>
              <b-dropdown-item aria-role="listitem" @click="_download('jpg')">
                <b-icon icon="file-image" pack="fas" size="is-small"></b-icon> JPG
              </b-dropdown-item>
              <b-dropdown-item aria-role="listitem" @click="_download('webp')">
                <b-icon icon="star" pack="fas" size="is-small"></b-icon> WebP
              </b-dropdown-item>
            </b-dropdown>
            <b-button size="is-small" type="is-primary" icon-left="save" icon-pack="fas"
              @click="$emit('epc-save-screenshot')"
              data-action="save-screenshot">
              {{ $t('save') }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "ViewerPanelScreenshot",

    props: {
      screenshot: { type: String, default: null },
      workLayer: { type: String, default: null }
    },

    methods: {
      async _download(format) {
        const fileName = (this.workLayer || 'screenshot') + '_' + Date.now()

        if (format === 'png') {
          this._triggerDownload(this.screenshot, fileName + '.png')
          return
        }

        const mimeTypes = { jpg: 'image/jpeg', webp: 'image/webp' }
        const blobUrl = await this._convertToFormat(this.screenshot, mimeTypes[format], 0.90)
        this._triggerDownload(blobUrl, fileName + '.' + format)
        URL.revokeObjectURL(blobUrl)
      },

      _convertToFormat(pngDataUrl, mimeType, quality) {
        return new Promise((resolve) => {
          const image = new Image()
          image.onload = () => {
            const canvas = document.createElement('canvas')
            canvas.width = image.width
            canvas.height = image.height
            const ctx = canvas.getContext('2d')
            ctx.fillStyle = '#FFFFFF'
            ctx.fillRect(0, 0, canvas.width, canvas.height)
            ctx.drawImage(image, 0, 0)
            canvas.toBlob((blob) => resolve(URL.createObjectURL(blob)), mimeType, quality)
          }
          image.src = pngDataUrl
        })
      },

      _triggerDownload(href, filename) {
        const link = document.createElement('a')
        link.href = href
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    }
  }

</script>

<style scoped>

  .viewer-right-panel {
    border-left: 1px solid #d4dbe1;
    border-top: 1px solid #d4dbe1;
    background: linear-gradient(to top, #eeeeee 0, #f7f7f7 8px, #fafafa 12px, #fff 20px);
    box-shadow: 0 1px 2px 0 rgba(0,0,0,.3);
  }
  .viewer-panel__close-btn {
      position: absolute;
      top: 0px;
      right: 5px;
      float: none;
      fill: #939ca5;
      cursor: pointer;
      display: block;
      z-index: 1;
  }

  .screenshot-container {
    width: 100%;
    border: 1px solid #d4dbe1;
    text-align: center;
    margin-bottom: 15px;
    border-radius: 4px;
    min-height: 50px;
    position: relative;
  }
  .img_screenshot {
    max-height: 150px;
    max-width: 100%;
    width: auto;
    border: 0;
    margin: 0;
    border-radius: 0;
  }

</style>
